import { Routes } from '@angular/router';

import { CMS_PERMISSIONS } from '../../core/constants/permissions';
import { permissionGuard } from '../../core/guards/permission.guard';

export const routeRoutes: Routes = [
  {
    path: 'rutas',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.routes.viewAny,
    },
    loadComponent: () => import('./pages/list/list').then((m) => m.RoutesList),
  },
  {
    path: 'rutas/crear',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.routes.create,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.RoutesForm),
  },
  {
    path: 'rutas/:id/editar',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.routes.update,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.RoutesForm),
  },
];
